export const loadClients = async function (context) {
    try {
        const response = await window.axios.get('pos/get/customers')
        context.commit('ADD_CLIENTS', response.data)
    } catch (e) {
        throw new Error(e)
    }
}

export const createClient = async function (context, clientInfo) {
    try {
        const response = await window.axios.post('store/client', clientInfo)
        await context.commit('ADD_CLIENT', response.data)
        context.commit('SET_ONLY_CLIENT_ID', response.data.id)
        return response.data
    } catch (e) {
        throw new Error(e)
    }
}

export const uploadAvatar = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('contact/upload-avatar', data).then(resolve).catch(reject)
    })
}
